var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.47631 2.64306C2.5 3.61937 2.5 5.19072 2.5 8.33341V11.6667C2.5 14.8094 2.5 16.3808 3.47631 17.3571C4.45262 18.3334 6.02397 18.3334 9.16667 18.3334H10.8333C13.976 18.3334 15.5474 18.3334 16.5237 17.3571C17.5 16.3808 17.5 14.8094 17.5 11.6667V8.33341C17.5 5.19072 17.5 3.61937 16.5237 2.64306C15.5474 1.66675 13.976 1.66675 10.8333 1.66675H9.16667C6.02397 1.66675 4.45262 1.66675 3.47631 2.64306ZM6.04167 6.66675C6.04167 6.32157 6.32149 6.04175 6.66667 6.04175H13.3333C13.6785 6.04175 13.9583 6.32157 13.9583 6.66675C13.9583 7.01193 13.6785 7.29175 13.3333 7.29175H6.66667C6.32149 7.29175 6.04167 7.01193 6.04167 6.66675ZM6.04167 10.0001C6.04167 9.6549 6.32149 9.37508 6.66667 9.37508H13.3333C13.6785 9.37508 13.9583 9.6549 13.9583 10.0001C13.9583 10.3453 13.6785 10.6251 13.3333 10.6251H6.66667C6.32149 10.6251 6.04167 10.3453 6.04167 10.0001ZM6.66667 12.7084C6.32149 12.7084 6.04167 12.9882 6.04167 13.3334C6.04167 13.6786 6.32149 13.9584 6.66667 13.9584H10.8333C11.1785 13.9584 11.4583 13.6786 11.4583 13.3334C11.4583 12.9882 11.1785 12.7084 10.8333 12.7084H6.66667Z",
    fill: "#54FF5B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/Check.da849f79bd334d23993b31bc6bbafcc4.svg";
export { ForwardRef as ReactComponent };